import { omit } from "lodash"
import React, { useEffect } from "react"
import { connect, useDispatch } from "react-redux"
import { Navigate, useNavigate } from "react-router"

import { callHasChanged } from "containers/Call/services/actions"
import { CALL_FINISHED } from "containers/Call/services/saga"
import { logout } from "containers/Login/services/actions"
import actionsPayment from "containers/Payment/services/actions"
import { Answer } from "containers/Survey/types"
import { PAYMENT_PAGE, PROFILE_PAGE, SURVEY_PAGE } from "core/constants"
import { DoctorType } from "types/entity"
import { CallState } from "types/payload"
import { Action, ActionWithoutPayload } from "types/redux"
import { CallStore, SocketStore, SurveyStore } from "types/store"

import { ConnectParams } from "./contexts/videoContext"
import LobbyCall from "./LobbyCall"
import {
  callHangupRequest,
  cancelCallRequest,
  getCall,
} from "./services/actions"
import { connectRoom } from "./services/video/actions"
import VideoCall from "./VideoCall"

const Call = (props: CallStore & { answers: Answer[] }): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    if (!props.call || !CALL_FINISHED.includes(props.call.state)) {
      props.getCurrentCall()
    }
  }, [])

  const relaunch = () => {
    dispatch(callHasChanged(undefined))
    if (props.call?.category_id === DoctorType.OPHTALMOLOGIST) {
      navigate(PAYMENT_PAGE)
    } else {
      navigate(SURVEY_PAGE)
    }
  }
  if (props.call)
    switch (props.call.state) {
      case CallState.ENDED:
        return <Navigate to={SURVEY_PAGE} replace />
      case CallState.STARTED:
        return <VideoCall {...omit(props, "answers")} />
      default:
        return <LobbyCall {...omit(props, "answers")} createCall={relaunch} />
    }
  else return <Navigate to={PROFILE_PAGE} replace />
}

const mapStateToProps = ({
  call,
  survey,
}: {
  call: CallStore
  socket: SocketStore
  survey: SurveyStore
}): CallStore & { answers: Answer[] } => {
  return { ...call, answers: survey.answers }
}

const mapDispatchToProps = (
  dispatch: (e: Action<unknown> | ActionWithoutPayload) => void
): Partial<CallStore> => {
  return {
    hangup: () => dispatch(callHangupRequest()),
    connect: (params: ConnectParams) => dispatch(connectRoom(params)),
    cancelCall: () => {
      dispatch(cancelCallRequest())
    },
    createCall: (r: Answer[]) => dispatch(actionsPayment.submit(r)),
    getCurrentCall: () => dispatch(getCall()),
    logout: () => dispatch(logout()),
  } as Partial<CallStore>
}

export default connect(mapStateToProps, mapDispatchToProps)(Call)
